export const updateOrder = (change) => ({
  type: "UPDATE_ORDER",
  payload: change
});

export const clearOrder = () => ({
  type: "CLEAR_ORDER",
});
